"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { CarouselPrevious, CarouselNextWithProgress, useCarousel } from "@repo/ui/carousel";
import type { BannerDataItem, BannerVariant } from "./general-banner.types";
import { getContentBgClass } from "./general-banner.utils";
import { BannerContent } from "./banner-content.component";
export function BannerContentFader(t0) {
  const $ = _c(13);
  const {
    banners,
    variant
  } = t0;
  const {
    selectedIndex
  } = useCarousel();
  let t1;
  if ($[0] !== banners || $[1] !== selectedIndex || $[2] !== variant) {
    const containerBg = variant === "promo" ? getContentBgClass(banners[selectedIndex]?.colour) : variant === "feature" ? "" : "bg-surface-base-interactive";
    t1 = cn("relative grid h-full grid-rows-[1fr_auto] transition-colors duration-700", containerBg);
    $[0] = banners;
    $[1] = selectedIndex;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== banners || $[5] !== selectedIndex) {
    let t3;
    if ($[7] !== selectedIndex) {
      t3 = (item, index) => <div key={item._id} aria-hidden={index !== selectedIndex} inert={index !== selectedIndex ? true : undefined} className={cn("col-start-1 row-start-1 flex flex-col items-center justify-center px-6 pt-8 tablet:pt-12 text-center transition-opacity duration-700", index === selectedIndex ? "opacity-100" : "opacity-0 pointer-events-none")}><div className="w-full max-w-md"><BannerContent item={item} /></div></div>;
      $[7] = selectedIndex;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = banners.map(t3);
    $[4] = banners;
    $[5] = selectedIndex;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="col-start-1 row-start-2 flex items-end justify-center gap-2 pt-6 pb-8 tablet:pt-8 tablet:pb-10"><CarouselPrevious /><CarouselNextWithProgress autoplayDelay={12000} /></div>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}